"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastsContainer = void 0;
var preact_1 = require("preact");
var toast_1 = require("../toast/toast");
var styles = require("./_toasts-container.scss");
var ToastsContainer = /** @class */ (function (_super) {
    __extends(ToastsContainer, _super);
    function ToastsContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToastsContainer.prototype.render = function () {
        return ((0, preact_1.h)("div", { className: styles.toastsContainer, "aria-live": "polite" }, this.props.toasts.map(function (toast) {
            return ((0, preact_1.h)("div", { className: styles.toastRow, key: toast.id },
                (0, preact_1.h)(toast_1.Toast, __assign({}, toast))));
        })));
    };
    return ToastsContainer;
}(preact_1.Component));
exports.ToastsContainer = ToastsContainer;
//# sourceMappingURL=toasts-container.js.map